module.exports = __webpack_public_path__ + "img/entrep.0d04dc2e.jpg";